export class UsuarioRefrescarToken {
    usuario: string;
    access_token: string;
}